import { createContext } from 'react';

import { useIntegrations } from 'hooks/useIntegrations';

export const IntegrationsContext = createContext<{
  isLoading: boolean;
  integrations: any[];
  refetch: () => void | undefined;
}>({
  isLoading: false,
  refetch: undefined,
  integrations: undefined,
});

export const IntegrationsProvider = ({ children }) => {
  const { data: integrations, isLoading, refetch } = useIntegrations();

  return (
    <IntegrationsContext.Provider
      value={{
        refetch,
        isLoading,
        integrations,
      }}
    >
      {children}
    </IntegrationsContext.Provider>
  );
};
